import React from 'react';
import styles from './Icons.scss';
import cn from 'classnames';
import { IconProps, Icons } from './IconsRes';
import { getIconClasses } from '@/Static/IconUtils';

export const PrintIcon = ({ id, size = 'small', className, onClick, disabled, dataAttributes }: IconProps) => {
  return (
    <img
      id={id}
      src={Icons.Printer}
      className={cn(styles.icon, styles.button, getIconClasses(size, disabled), className)}
      onClick={() => {
        if (!disabled) onClick?.();
      }}
      {...dataAttributes}
    />
  );
};
